module.exports = ".sub_list{\r\n\tpadding-left: 40px\r\n}\r\n\r\n.head{\r\n    margin-top:10px;\r\n}\r\n\r\n.dashhead{\r\n    margin-top: 120px;\r\n}"